const ROUTES = {
  splash: "/",
  pay: "/pay",
  directQrPay: "/p/:qr_code",
  services: "/services",
  transactions: "/transactions",
  transactionDetails: `/transaction-details/:id`,
  profile: "/profile",
  editProfile: "/edit-profile",
  password: "/password",
  mobileRecharge: "/mobile-recharge",
  mobileInternet: "/mobile-internet",
  freeway: "/freeway",
  traffic: "/traffic",
  payWithCode: "/pay-with-code",
  login: "/login",
  topup: "/topup",
  checkout: "/checkout",
  referal: "/referal",
  failedIpg: "/failed",
  successIpg: "/success",
};

export default ROUTES;
